import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardMeasureUnitsEdit = guard(groupRights.MeasureUnits)('edit')
export const guardMeasureUnitsWatch = guard(groupRights.MeasureUnits)('watch')
export const guardMeasureUnitsCreate = guard(groupRights.MeasureUnits)('create')

